const Form017EN = {
    stepName: {
        importantNotes: "Important Notes",
        applicationInformation: "Application Information",
        confirmation: "Confirmation",
    },
    label: {
        note: {
            title: "Notes",
            note1: "Please make ready the scanned copies / images of the supporting documents in the file format of JPG, PNG or PDF if necessary:",
            note2: "(The maximum size of all files should not exceed 10MB.)",
            note3: `You need an "iAM Smart" account with digital signing function for the online application form.`,
            note4: "Please submit the school development portfolio in duplicate with this application form:",
            note5: "by hand to the Professional Development and Training Division, Education Bureau on 5/F, East Wing, Central Government Offices, 2 Tim Mei Avenue, Tamar, Hong Kong. (Please ring up the School Leadership and Professional Development Section on 3509 7471 at least 2 working days prior to the submission to facilitate the pre-registration for entry to the Central Government Offices);",
            note5a: " OR",
            note6: "by registered mail to the School Leadership and Professional Development Section, Professional Development and Training Division, Education Bureau, 5/F, East Wing, Central Government Offices, 2 Tim Mei Avenue, Tamar, Hong Kong.",
        },
        termsConditions:
            "I have read, understood and agreed to the above terms and conditions.",
        iamSignCheck:
            "I understand applicant needs to have an “iAM Smart+” account to process the application.",
        refNo: "Ref No.:",
        refNo2: "(For office use only)",
        nameOfApplicanEn:
            "Name of Applicant (must be identical with that of the applicant's HK Identity Card)(English)",
        nameOfApplicanCh:
            "Name of Applicant (must be identical with that of the applicant's HK Identity Card)(Chinese, if applicable)",
        correspondenceAddress: "Correspondence Address",
        contactTelephone: "Contact Telephone No.(School / Office)",
        schoolOrOfficeOption: {
            school: "School Contact Telephone No.",
            office: "Office Contact Telephone No.",
        },
        contactTelephoneNo: "Contact Telephone No.(Home / Mobile)",
        HomeOrMobileOption: {
            home: "Home Contact Telephone No.",
            mobile: "Mobile Contact Telephone No.",
        },
        faxNo: "Fax No.",
        emailAddress: "E-mail Address",
        hKIdentityCardOrPassportNo: "HK Identity Card / Passport No.",
        hKIdentityCardOrPassportNoOption: {
            hkic: "HK Identity Card",
            passport: "Passport No.",
        },
        registeredTeacherOrPermittedTeacher:
            "Registered Teacher / Permitted Teacher",
        registeredTeacherOrPermittedTeacherOption: {
            registeredTeacher: "Registered Teacher",
            permittedTeacher: "Permitted Teacher",
        },
        appointmentToPrincipalship: "Appointment to Principalship",
        noteList: "Your application cannot be submitted.",
        noteList1: "If your CFP has expired and you wish to hold a valid CFP ",
        noteList2: "before the appointment as a principal",
        noteList3: ", you may apply to restart the CFP process.",
        confirm: "confirm",
        appointmentToPrincipalshipOption: {
            yes: "Yes",
            no: "No",
        },
        dateOfAppointmentToPrincipalship:
            "Date of appointment to Principalship",
        schoolOrganisation:
            "Name and Address of Applicant's School / Organisation",
        schoolOrganisationOption: {
            school: "School",
            organisation: "Organisation",
        },

        name: "Name of Applicant's School",
        name1: "Name of Applicant's Organisation",
        address: "Address of Applicant's School",
        address1: "Address of Applicant's Organisation",
        typeOfSchool: "Type of School",
        typeOfSchoolOption1: {
            primary: "Primary",
            secondary: "Secondary",
            special: "Special",
        },
        typeOfSchoolOption2: {
            government: "Government",
            aided: "Aided",
            dss: "DSS",
            caput: "Caput",
            others: "Others(Please specify)",
        },
        // typeOfSchoolOption: {

        //     primary: "Primary",
        //     secondary: "Secondary",
        //     special: "Special",
        //     government: "Government",
        //     aided: "Aided",
        //     dss: "DSS",
        //     caput: "Caput",
        //     others: "Others(Please specify)",
        // },
        specify: "Please specify:",
        issueDateOfCFP: "Issue Date of CFP",

        header: " Please √ as appropriate. ",
        // reason: "Reason(s):",

        declaration: "Declaration",
        note1: "I declare,",
        // declarationContentList: [
        //     "that I have read and understood the “Guidelines on School Development Portfolio”;",
        //     "that the personal data entered in my application form and all the factual information contained in my school development portfolio for this application are true and accurate; and",
        //     "that the school development portfolio is entirely my own work except where I have duly acknowledged other sources and put the copied parts in quotations in the portfolio. The school development portfolio is in compliance with the copyright laws#.",
        // ],
        declaration1:
            'that I have read and understood the "Guidelines on School Development Portfolio";',
        declaration2:
            "that the personal data entered in my application form and all the factual information contained in my school development portfolio for this application are true and accurate; and",
        declaration3:
            "that the school development portfolio is entirely my own work except where I have duly acknowledged other sources and put the copied parts in quotations in the portfolio. The school development portfolio is in compliance with the copyright laws",

        errorMsg: {
            nameOfApplicanEn: "Please input a valid name of applican (English)",
            nameOfApplicanCh: "Please input a valid name of applican (Chinese)",
            correspondenceAddress:
                "Please input a valid correspondence address",
            contactTelephone: "Please input a valid contact telephone number",
            school: "Please input a valid school contact telephone number",
            office: "Please input a valid office contact telephone number",
            home: "Please input a valid home contact telephone number",
            mobile: "Please input a valid mobile contact telephone number",
            faxNo: "Please input a valid fax number",
            emailAddress: "Please input a valid email address",
            hkic: "Please input a valid hk identity card number",
            passport: "Please input a valid passport number",
            registeredTeacher: "Please input a valid  registered teacher",
            permittedTeacher: "Please input a valid permitted teacher",
            appointmentToPrincipalship:
                "Please input a valid appointment to principalship",
            dateOfAppointmentToPrincipalship:
                "Please input date before today or after today",
            name: "Please input a valid name of applicant’s school",
            address: "Please input a valid address of applicant’s school",
            name1: "Please input a vali name of applicant’s organisation",
            address1:
                "Please input a valid address of applicant’s organisation",
            issueDateOfCFP: "Please input a valid issue date of cfp",
            otherInput: "Please input a valid reason",
            E0001: "If you choose the others, please state why",
        },
        attachment: "Annex",
        completedByEDB: "To be completed by the Education Bureau",
    },
    submittedDialog: {
        note1: "The application is submitted successfully.",
        note2: "Please submit the ",
        note3: "school development portfolio in duplicate ",
        note4: "with this ",
        note5: "application form",
        note6: ":",
        note7: "by hand to the Professional Development and Training Division, Education Bureau on 5/F, East Wing, Central Government Offices, 2 Tim Mei Avenue, Tamar, Hong Kong. (Please ring up the School Leadership and Professional Development Section on 3509 7471 at least 2 working days prior to the submission to facilitate the pre-registration for entry to the Central Government Offices); OR",
        note8: "by registered mail to the School Leadership and Professional Development Section, Professional Development and Training Division, Education Bureau, 5/F, East Wing, Central Government Offices, 2 Tim Mei Avenue, Tamar, Hong Kong.",
    },
};
export default Form017EN;
